import type { ExternalReportCategory, ReportCategory } from '@/modules/api';

export class ReportCategoryGuard {
  public static isReportCategory(
    category: ReportCategory | ExternalReportCategory | undefined | null,
  ): category is ReportCategory {
    return !!category && 'id' in category;
  }

  public static isExternalReportCategory(
    category: ReportCategory | ExternalReportCategory | undefined | null,
  ): category is ExternalReportCategory {
    return !!category && 'code' in category;
  }
}
